export default {
  'new-vacancy': 'Nueva vacante',
  'second-round': 'Segunda terna',
  'scholar-replacement': 'Sustitución de becario',
  'vacancy-expiration': 'Vencimiento de vacante'
}